import Avatar from '@components/avatar';
import Buy from '@components/buy';
import { rankingIcons } from '@constants/icons';
import { useSuiNSName } from '@hooks/use-sui-ns-name';
import { formatDigitUnit } from '@utils/format-digit-unit';
import { timeDifference } from '@utils/time-difference';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { type FC } from 'react';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';

const PumpItemMobile: FC<{
  index: number;
  item:
    | OpenapiClientPump.GetRankingsMarketCapResponse[number]
    | OpenapiClientPump.GetRankingsChangesResponse[number];
}> = ({ index, item }) => {
  const icon = rankingIcons[index];
  const navigate = useNavigate();
  const suiNames = useSuiNSName(item.created_by);

  return (
    <div className={styles.wrapper} onClick={() => navigate(`/fun/${item.token_address}`)}>
      <div className={`${styles.ranking}`}>
        <span>{icon ? <img src={icon} /> : index + 1}</span>

        <img src={item.token_metadata.iconUrl} />
        <div className={styles.name_symbol}>
          <p>{item.token_metadata.name} </p>
          <p>${item.token_metadata.symbol}</p>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.line}>
          <div className={styles.line_title}>Created by</div>
          <div className={styles.sender}>
            <Avatar address={item.created_by} className={styles.create_icon} />

            <div className={styles.create_sender}>
              {suiNames || item.created_by.slice(item.created_by.length - 8)}
            </div>
          </div>
        </div>
        <div className={styles.line}>
          <div className={styles.line_title}>Market Cap</div>
          <div className={styles.market}>
            <div className={styles.market_value}>${formatDigitUnit(item.market_cap_usd, 2)}</div>
            <div className={`${styles.market_change} ${item.change_24h >= 0 ? '' : styles.neg}`}>
              {item.change_24h >= 0 ? '+' : ''}
              {Number(item.change_24h.toFixed(2))}%
            </div>
          </div>
        </div>
        <div className={styles.line}>
          <div className={styles.line_title}>{timeDifference(item.deployed_at, 1)} ago</div>
          <div>
            <Buy
              token_address={item.token_address}
              name={item.token_metadata.name}
              symbol={item.token_metadata.symbol}
              iconUrl={item.token_metadata.iconUrl}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PumpItemMobile;
